
// import Swiper from 'swiper/bundle';
import Swiper from 'swiper/bundle';
// import 'swiper/css';

export default () => {
    const recentPostsSliders = document.querySelectorAll('.swiper.recent-posts');
    if (recentPostsSliders) {
        recentPostsSliders.forEach(el => {
            new Swiper(el, {
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                centeredSlides: false,
                spaceBetween: 0,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                lazy: {
                    loadPrevNext: true,
                },
                freeMode: {
                    enabled: true,
                    momentumBounce: false,
                    sticky: true,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 80,
                    },
                },
            });
        });
    }
}
